import { useCompassCard } from '@scale/compass-ui/store';
import { useEffect } from 'react';
import {
  ChatBulkAuditObjectType,
  ChatBulkAuditContext,
} from '@scale/genai-compass-shared/cards/chat_bulk_audit';

const useChatBulkAuditCard = (index: number) => {
  const { card, updateCardContext, updateCardCanSubmit } =
    useCompassCard<ChatBulkAuditContext>(index);
  const context = card.defaultContext;
  const { retrievedOutput } = useCompassCard(index - 1);
  const data = retrievedOutput?.response?.data;

  const [objectType, setObjectType] = [
    context.objectType,
    (objectType: ChatBulkAuditObjectType) => {
      updateCardContext({ ...context, objectType });
    },
  ];

  const [objectIds, setObjectIds] = [
    context.objectIds,
    (objectIds: string[]) => {
      updateCardContext({ ...context, objectIds });
    },
  ];

  const [auditName, setAuditName] = [
    context.auditName,
    (auditName: string) => {
      updateCardContext({ ...context, auditName });
    },
  ];

  const [objectIdsColumnName, setObjectIdsColumnName] = [
    context.objectIdsColumnName,
    (objectIdsColumnName: string) => {
      updateCardContext({ ...context, objectIdsColumnName });
    },
  ];

  const [shouldClaimTasks, setShouldClaimTasks] = [
    context.shouldClaimTasks,
    (shouldClaimTasks: boolean) => {
      updateCardContext({ ...context, shouldClaimTasks });
    },
  ];

  const [projectId, setProjectId] = [
    context.projectId,
    (projectId: string) => {
      updateCardContext({ ...context, projectId });
    },
  ];

  const [dateRange, setDateRange] = [
    context.dateRange,
    (dateRange: { startDate: Date; endDate: Date }) => {
      updateCardContext({ ...context, dateRange });
    },
  ];

  const [limit, setLimit] = [
    context.limit,
    (limit: number) => {
      updateCardContext({ ...context, limit });
    },
  ];

  useEffect(() => {
    updateCardCanSubmit(
      !!context.auditName &&
        !!context.objectType &&
        !!context.objectIdsColumnName &&
        (!(context.objectType === ChatBulkAuditObjectType.WORKER) || !!context.limit) &&
        (data ?? []).length > 0,
    );
  }, [
    context.auditName,
    context.objectType,
    context.objectIdsColumnName,
    context.limit,
    data,
    updateCardCanSubmit,
  ]);

  return {
    projectId,
    setProjectId,
    objectType,
    setObjectType,
    objectIds,
    setObjectIds,
    auditName,
    setAuditName,
    objectIdsColumnName,
    setObjectIdsColumnName,
    shouldClaimTasks,
    setShouldClaimTasks,
    dateRange,
    setDateRange,
    limit,
    setLimit,
  };
};

export default useChatBulkAuditCard;
